
    /* Megamenu - hide items with '- hide' in the title */
    $('.site-nav__dropdown-link:contains("- hide")').hide()
    